

































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import { ITag } from "@/models/tags";
import { DataModules } from "@/store/modules/data";
import { IBrand } from "@/models/brands";

interface IForm {
  name: string;
  colour: string;
  description: string;
  brand_id: IBrand["id"];
}

@Component
export default class TagAddEditModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  @Prop({ required: false, default: null })
  public tag!: ITag;

  public loading = false;
  public isProcessing = false;
  public form: IForm = {
    name: this.$_.get(this.tag, "name", ""),
    colour: this.$_.get(this.tag, "colour", ""),
    description: this.$_.get(this.tag, "description", ""),
    brand_id: this.$_.get(this.tag, "brand_id", "")
  };

  public get isCreate() {
    return this.$_.isEmpty(this.tag);
  }
  public get isMultibrand() {
    return this.$store.getters["brand/isMultibrand"];
  }

  public get brands() {
    return this.$store.state.auth.admin.brands;
  }

  // Methods

  public validateBeforeSubmit() {
    this.validate().then(result => {
      if (result) {
        // @ts-ignore
        this.save();
      } else {
        this.isProcessing = false;
        this.$buefy.toast.open({
          message: this.$t("_.form_invalid") as string,
          type: "is-danger"
        });
      }
    });
  }

  public update() {
    this.isProcessing = true;
    this.$store
      .dispatch(`data/${DataModules.TAGS}/update`, {
        vm: this,
        id: this.tag.id,
        data: {
          ...this.tag,
          ...this.form
        }
      })
      .then(() => {
        this.isProcessing = false;
        this.$emit("success");
      })
      .catch(error => {
        this.isProcessing = false;
        this.$store.dispatch("api/handleError", error);
      });
  }

  public save() {
    if (this.tag) {
      return this.update();
    }

    this.isProcessing = true;
    const payload = !this.isMultibrand
      ? this.$_.omit(this.form, ["brand_id"])
      : this.form;
    this.$store
      .dispatch(`data/${DataModules.TAGS}/create`, {
        vm: this,
        data: payload
      })
      .then(() => {
        this.isProcessing = false;
        this.$emit("success");
      })
      .catch(error => {
        this.isProcessing = false;
        this.$store.dispatch("api/handleError", error);
      });
  }

  // Computed

  public get title() {
    if (this.tag) {
      return this.$t("_action.update_object", {
        // @ts-ignore
        object: this.$t("_.tag").toLowerCase()
      });
    }
    return this.$t("_action.create_object", {
      // @ts-ignore
      object: this.$t("_.tag").toLowerCase()
    });
  }

  public get formIsValid(): boolean {
    if (
      this.$_.isEmpty(this.form.name) ||
      this.$_.isEmpty(this.form.colour) ||
      (this.isMultibrand && !this.form.brand_id)
    ) {
      return false;
    }

    return true;
  }

  public get formIsDisabled(): boolean {
    return (
      this.isProcessing || !this.formIsValid || this.hasErrors || this.loading
    );
  }
}
